import { formatMessage } from '../../../utils/i18n';

export const getCouponDates = (frequency: number | undefined, frequencyUnit: string | undefined) => {
  if (frequency === undefined || frequencyUnit === undefined) {
    return undefined;
  }

  const strategies = new Map([
    ['Day_180', 'Semiannually'],
    ['Month_6', 'Semiannually'],
    ['Month_3', 'Quarterly'],
    ['Month_1', 'Monthly'],
    ['Year_1', 'Annually'],
  ]);

  const condition = `${frequencyUnit}_${frequency}`;
  const match = strategies.get(condition);
  return match
    ? formatMessage(`Comparison.Table.FixedIncomeMetrics.${match}`)
    : formatMessage(`Comparison.Table.FixedIncomeMetrics.${frequencyUnit}`, { count: frequency || '' });
};
